var React = require('react');

function PersonCarry (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80 0a48 48 0 1 0 48 48A48 48 0 0 0 80 0zm288 96H208a16 16 0 0 0-16 16v176h176a16 16 0 0 0 16-16V112a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 479.9a32 32 0 0 0 64 0v-74.5C48 391.7.6 350.8 0 350.3zM128 288h64v-64h-25.4l-33.3-61.8A63.81 63.81 0 0 0 76.7 128H48a48 48 0 0 0-48 48v103a64.05 64.05 0 0 0 22.4 48.6l76 65.1 14.1 92.5c1 5.7 10.1 30.7 36.8 26.3a32 32 0 0 0 26.3-36.8l-14.1-92.5a64.41 64.41 0 0 0-21.5-38.1l-44-37.7v-78.3z","className":"fa-primary","key":2})]);
}

PersonCarry.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = PersonCarry;

PersonCarry.default = PersonCarry;
